export enum LoyaltyRouteNames {
  LOYALTY_ROOT = 'LoyaltyRoot',

  CAMPAIGNS_LIST = 'LoyaltyRoot/Campaigns',
  CAMPAIGNS_CREATE = 'LoyaltyRoot/Campaigns/Create',
  CAMPAIGNS_DETAIL = 'LoyaltyRoot/Campaigns/Detail',
  CAMPAIGNS_EDIT = 'LoyaltyRoot/Campaigns/Edit',

  VOUCHERS_LIST = 'LoyaltyRoot/Vouchers',
  VOUCHERS_CREATE = 'LoyaltyRoot/Vouchers/Create',
  VOUCHERS_DETAIL = 'LoyaltyRoot/Vouchers/Detail',

  REWARDS_LIST = 'LoyaltyRoot/Rewards',
  REWARDS_CREATE = 'LoyaltyRoot/Rewards/Create',
  REWARDS_DETAIL = 'LoyaltyRoot/Rewards/Detail',
  REWARDS_EDIT = 'LoyaltyRoot/Rewards/Edit',
  REWARDS_CARD_DETAIL = 'LoyaltyRoot/Rewards/CardDetail',

  SEGMENTS_LIST = 'LoyaltyRoot/Segments',
  SEGMENTS_CREATE = 'LoyaltyRoot/Segments/Create',
  SEGMENTS_DETAIL = 'LoyaltyRoot/Segments/Detail',
  SEGMENTS_EDIT = 'LoyaltyRoot/Segments/Edit',

  BUNDLES_LIST = 'LoyaltyRoot/Bundles',
  BUNDLES_CREATE = 'LoyaltyRoot/Bundles/Create',
  BUNDLES_DETAIL = 'LoyaltyRoot/Bundles/Detail',
  BUNDLES_EDIT = 'LoyaltyRoot/Bundles/Edit',

  REPORTING_CAMPAIGNS = 'LoyaltyRoot/Reporting/Campaigns',
  REPORTING_CUSTOMERS = 'LoyaltyRoot/Reporting/Customers',
}
